import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(value?: Date) {
  if (value && value.toString() != "-") {
    return moment(String(value)).format("DD-MM-YYYY");
  } else {
    return value;
  }
});

Vue.filter("formatTime", function(value?: Date) {
  if (value) {
    return moment(String(value)).format("HH:mm:ss");
  }
});

Vue.filter("formatDateTime", function(value?: Date) {
  if (value) {
    const formatDate = Vue.filter("formatDate");
    const formatTime = Vue.filter("formatTime");
    return formatDate(value) + " " + formatTime(value);
  }
});

Vue.filter("formatGender", function(value?: string) {
  if (value) {
    if (value === "M") {
      return "Man";
    } else if (value === "F") {
      return "Vrouw";
    }
  }
});

Vue.filter("genderIcon", function(value?: string, twin?: boolean) {
  if (value) {
    if (value === "M") {
      if (twin) {
        return "fas fa-mars-double a-gender-male";
      } else {
        return "fas fa-mars a-gender-male";
      }
    } else if (value === "F") {
      if (twin) {
        return "fas fa-venus-double a-gender-male";
      } else {
        return "fas fa-venus a-gender-female";
      }
    } else if (value === "UN") {
      return "fas fa-transgender a-gender-less";
    }
  }
});

Vue.filter("formatExtraInformation", function(value?: string) {
  if (value) {
    return value.replace(/;/g, ";<br>");
  }
});
